import styles from './Footer.module.scss';
import {businessDetails, BUSINESS_NAME} from '@/content';
import {useTheme} from "@mui/material/styles";
import {footerData }from "@/content";
import Box from "@mui/material/Box";
import {MenuType} from "@/types";
import Link from "next/link"
import SocialFooterBlock from "@/ui/social-footer-block/social-footer-block";

const Footer = () => {
    const {
    branding:{
        footerLogoUrl
    }} = businessDetails;
    const date = new Date();

    const theme = useTheme();
    const gradient = `linear-gradient(${theme.custom.footerBackgroundGradient.direction}, ${theme.custom.footerBackgroundGradient.start}, ${theme.custom.footerBackgroundGradient.end})`;

    return (
        <footer className={styles.app_footer}>
            <Box
                style={{
                    backgroundImage: gradient, // Apply gradient
                    color: theme.palette.text.primary,
                }}
            >
                <div>
                    <div>
                        <div className={styles.footer_title}>{footerData[0].label}</div>
                        {footerData[0].children.map((d: MenuType, i: number) => (
                            <div key={i}><Link href={d.href === '/' ? d.href : `/${d.href}`} title={d.label}>{d.label}</Link>
                            </div>
                        ))
                        }
                    </div>
                    <div>
                        <Link className={styles.footer_title} href={footerData[1].href}>{footerData[1].label}</Link>
                        {footerData[1].children.map((d: MenuType, i: number) => (
                            <div key={i}><Link href={d.href === '/' ? d.href : `/${d.href}`} title={d.label}>{d.label}</Link>
                            </div>
                        ))
                        }
                    </div>
                    <div>
                        <div>
                            <Link className={styles.footer_title} href={footerData[2].href}>{footerData[2].label}</Link>
                            {footerData[2].children.map((d: MenuType, i: number) => (
                                <div key={i}><Link href={d.href === '/' ? d.href : `/${d.href}`}
                                                   title={d.label}>{d.label}</Link>
                                </div>
                            ))
                            }
                        </div>
                    </div>
                    <div>
                        <div className={styles.logo_block}>
                            <img
                                src={footerLogoUrl}
                                title={BUSINESS_NAME}
                                alt={BUSINESS_NAME}
                            />
                        </div>
                        <SocialFooterBlock hideHandles/>
                    </div>
                </div>
            </Box>
            <div>
                <div>
                    <div>
                        {businessDetails.companyData.licenseNumber ?? ''}
                    </div>
                    <div>
                        ©{BUSINESS_NAME} {date.getFullYear()}
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
